<template>
<div :id="page_slug">

    <div class="crumbs-bar">
      <el-row>
        <el-col :span="12">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ name: 'DashboardPage' }">Dashboard</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ name: 'ProductTagList' }">Tags</el-breadcrumb-item>
            <el-breadcrumb-item>Edit</el-breadcrumb-item>
          </el-breadcrumb>        
        </el-col>      
      </el-row>
    </div>

    <el-form
  ref="tag"
    :rules="rules.tag"
    :model="tag"
    :label-position="label_position">

        <el-form-item label="Name" prop="name">
            <el-input v-model="tag.name"></el-input>
        </el-form-item>
        <el-form-item label="Created User Id" prop="created_user_id">
            <el-input v-model="tag.created_user_id"></el-input>
        </el-form-item> 
        <el-form-item label="Updated User Id" prop="updated_user_id">
            <el-input v-model="tag.updated_user_id"></el-input>
        </el-form-item> 
        <el-form-item label="Sort Order" prop="sort_order">
            <el-input v-model="tag.sort_order"></el-input>
        </el-form-item> 

         <el-form-item label="Tag Is Hidden">
            <el-switch
                :inactive-value="0"
                :active-value="1"
                v-model="tag.tag_is_hidden">
            </el-switch>
        </el-form-item>


        <el-form-item>
          <el-button type="primary" @click="updateTag('tag')">Update</el-button>
        </el-form-item>

   </el-form>

  <pre v-if="config.debug">{{$data}}</pre>

</div>
</template>

<style>

</style>

<script>

    import Config from '@/store/Config.js';

    export default {
        data: function() {
            return {
                config: Config.config,
                page_alias: 'Add Tag',
                page_slug: 'add',
                label_position: 'top',
                loading: false,
                rules: {
                    tag: {
                        tag_name: [
                            {required: true, message: 'Please Enter Product Name', trigger: 'blur'}
                        ],
                        created_user_id: [
                            {required: true, message: 'Please Enter ', trigger: 'blur'},
                        ],
                        updated_user_id: [
                            {required: true, message: 'Please Enter ', trigger: 'blur'},
                        ],
                        sort_order: [
                            {required: true, message: 'Please Enter ', trigger: 'blur'},
                        ],
                        tag_is_hidden: [
                            {required: true, message: 'Please Enter ', trigger: 'blur'},
                        ],
                        created_at: [
                            {required: true, message: 'Please Enter ', trigger: 'blur'},
                        ],
                        updated_at: [
                            {required: true, message: 'Please Enter ', trigger: 'blur'},
                        ],
                    }
                },

                tag: {
                    tag_name: '',
                    created_user_id: '',
                    updated_user_id: '',
                    sort_order: '',
                    tag_is_hidden: '',
                    created_at: '',
                    updated_at: '',
                },
            };  
        },

        mounted: function() {
            const me = this;
            me.getTag();
        },

        methods: {
            getTag: function() {
                console.log('get tag function');
                const me = this;
                // start the loader
                me.loading = true;
                me.$http.get(me.config.api + 'productTag/{id}', {params: {id : me.$route.params.id}}).then(
                    response => {
                        console.log('Success Getting Data')  
                        // get status
                        console.log(response.status);
                        // get status text
                        console.log(response.statusText);
                        // get body data
                        me.tag = response.body.data;
                        me.loading = false;
                    }, response => {
                        // error callback
                        console.log('Error Getting Data');
                        // get status
                        console.log(response.status);
                        // get status text
                        console.log(response.statusText);
                        me.$notify({
                            title: 'Error',
                            message: response.statusText,
                            stype: 'error'
                        });
                        // end the loader
                        me.loading = false;
                    }
                );
            },

            updateTag: function(formName) {
                console.log('update tag function');
                const me = this;
                me.$refs[formName].validate((valid) => {
                    if (valid) {
                        me.$http.post(me.config.api + 'productTag', me.tag).then(
                        response => {
                            console.log('success putting data')  
                            console.log(response.status);
                            console.log(response.statusText);

                            me.getTag();

                            me.$notify({
                                title: 'Success',
                                message: 'The Tag Was Updated',
                                type: 'success'
                            });
                        }, response => {
                            console.log('Error Getting Data');
                            console.log(response.status);
                            console.log(response.statusText);
                        });
                    } else {
                        console.log('Fields Not Valid');
                        return false;
                    }
                });   
            },

            resetForm(formName) {
                const me = this;
                this.$refs[formName].resetFields();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/product-tags/ProductTagEdit.vue